import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
export default function ViewTransactionsRanges() {
  dayjs.extend(quarterOfYear);

  const dateOptions = [
    {
      date: "Today",
      actualValue: {
        start: dayjs().startOf("day").toDate(),
        end: dayjs().endOf("day").toDate(),
      },
    },
    {
      date: "Yesterday",
      actualValue: {
        start: dayjs().subtract(1, "day").startOf("day").toDate(),
        end: dayjs().subtract(1, "day").endOf("day").toDate(),
      },
    },
    {
      date: "This Week",
      actualValue: {
        start: dayjs().startOf("week").toDate(),
        end: dayjs().endOf("week").toDate(),
      },
    },
    {
      date: "This Week – to – Date",
      actualValue: {
        start: dayjs().startOf("week").toDate(),
        end: dayjs().toDate(),
      },
    },
    {
      date: "Last Week",
      actualValue: {
        start: dayjs().subtract(1, "week").startOf("week").toDate(),
        end: dayjs().subtract(1, "week").endOf("week").toDate(),
      },
    },
    {
      date: "Last Week–to–Date",
      actualValue: {
        start: dayjs().subtract(1, "week").startOf("week").toDate(),
        end: dayjs().subtract(1, "week").toDate(),
      },
    },
    {
      date: "This Month",
      actualValue: {
        start: dayjs().startOf("month").toDate(),
        end: dayjs().endOf("month").toDate(),
      },
    },
    {
      date: "This Month – to – Date",
      actualValue: {
        start: dayjs().startOf("month").toDate(),
        end: dayjs().toDate(),
      },
    },
    {
      date: "Last Month",
      actualValue: {
        start: dayjs().subtract(1, "month").startOf("month").toDate(),
        end: dayjs().subtract(1, "month").endOf("month").toDate(),
      },
    },
    {
      date: "Last Month – to – Date",
      actualValue: {
        start: dayjs().subtract(1, "month").startOf("month").toDate(),
        end: dayjs().subtract(1, "month").toDate(),
      },
    },
    {
      date: "This Quarter",
      actualValue: {
        start: dayjs().startOf("quarter").toDate(),
        end: dayjs().endOf("quarter").toDate(),
      },
    },
    {
      date: "This Quarter – to – Date",
      actualValue: {
        start: dayjs().startOf("quarter").toDate(),
        end: dayjs().toDate(),
      },
    },
    {
      date: "Last Quarter",
      actualValue: {
        start: dayjs().subtract(1, "quarter").startOf("quarter").toDate(),
        end: dayjs().subtract(1, "quarter").endOf("quarter").toDate(),
      },
    },
    {
      date: "Last Quarter – to – Date",
      actualValue: {
        start: dayjs().subtract(1, "quarter").startOf("quarter").toDate(),
        end: dayjs().subtract(1, "quarter").toDate(),
      },
    },
    {
      date: "This Year",
      actualValue: {
        start: dayjs().startOf("year").toDate(),
        end: dayjs().endOf("year").toDate(),
      },
    },
    {
      date: "This Year – to – Date",
      actualValue: {
        start: dayjs().startOf("year").toDate(),
        end: dayjs().toDate(),
      },
    },
    {
      date: "Last Year",
      actualValue: {
        start: dayjs().subtract(1, "year").startOf("year").toDate(),
        end: dayjs().subtract(1, "year").endOf("year").toDate(),
      },
    },
    {
      date: "Last Year – to – Date",
      actualValue: {
        start: dayjs().subtract(1, "year").startOf("year").toDate(),
        end: dayjs().subtract(1, "year").toDate(),
      },
    },
    {
      date: "Range",
      actualValue: {
        start: null,
        end: null,
      },
    },
    // {
    //   date: "Range",
    //   actualValue: {
    //     start: dayjs().subtract(7, "day").toDate(),
    //     end: dayjs().toDate(),
    //   },
    // },
    {
      date: "Past 90 Days",
      actualValue: {
        start: dayjs().subtract(90, "day").toDate(),
        end: dayjs().toDate(),
      },
    },
  ];

  return dateOptions;
}
